var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbound-wrapper"
  }, [_c('div', {
    staticClass: "main-tabs"
  }, [_c('div', {
    class: ['tab', _vm.activeMainTab === 'Inbound' ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.switchMainTab('Inbound')
      }
    }
  }, [_vm._v("Inbound Shortage Request")]), _vm._v(" "), _c('div', {
    class: ['tab', _vm.activeMainTab === 'User' ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.switchMainTab('User')
      }
    }
  }, [_vm._v("Unlock Trip User")]), _vm._v(" "), _c('div', {
    class: ['tab', _vm.activeMainTab === 'FMBagging' ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.switchMainTab('FMBagging')
      }
    }
  }, [_vm._v("FM Handover Shortage Request")]), _vm._v(" "), _c('div', {
    class: ['tab', _vm.activeMainTab === 'UserTrips' ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.switchMainTab('UserTrips')
      }
    }
  }, [_vm._v("Search User Trips")])]), _vm._v(" "), (_vm.activeMainTab === 'Inbound' && _vm.isCompleteInboundFeatureEnabled && _vm.isAuthorizedForRelease) ? _c('div', [_c('vue-element-loading', {
    attrs: {
      "active": _vm.isLoading,
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), (_vm.showResults && _vm.mandates && _vm.mandates.length > 0) ? _c('table', {
    staticClass: "table-box"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.mandates), function(m, index) {
    return _c('tr', {
      key: index,
      on: {
        "click": function($event) {
          _vm.selectedMandate = m
        }
      }
    }, [_c('td', {
      staticClass: "thc-click",
      on: {
        "click": function($event) {
          return _vm.openPendingModal(m)
        }
      }
    }, [_vm._v(_vm._s(m.thcno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.vehicleno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.connectionname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.bagno_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.shippingid_count))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showResults && _vm.mandates.length === 0) ? _c('p', [_vm._v("No pending trips found.")]) : _vm._e(), _vm._v(" "), (_vm.showResults && _vm.total > _vm.limit) ? _c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.page === 1
    },
    on: {
      "click": function($event) {
        _vm.page--;
        _vm.fetchMandateList()
      }
    }
  }, [_vm._v("Prev")]), _vm._v(" "), _c('span', [_vm._v("Page " + _vm._s(_vm.page) + " of " + _vm._s(Math.ceil(_vm.total / _vm.limit)))]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.page >= Math.ceil(_vm.total / _vm.limit)
    },
    on: {
      "click": function($event) {
        _vm.page++;
        _vm.fetchMandateList()
      }
    }
  }, [_vm._v("Next")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activeMainTab === 'User' && _vm.isCompleteInboundFeatureEnabled && _vm.isAuthorizedForRelease) ? _c('div', {
    staticClass: "user-section"
  }, [_c('div', {
    staticClass: "search-block"
  }, [_c('label', [_vm._v("Vehicle / THC No :")]), _vm._v(" "), _c('div', {
    staticClass: "search-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchThc),
      expression: "searchThc",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search THC No or Vehicle No"
    },
    domProps: {
      "value": (_vm.searchThc)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchThc = $event.target.value.trim()
      }, _vm.filterMandates],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "reset-btn",
    on: {
      "click": _vm.resetSearch
    }
  }, [_vm._v("Reset")])]), _vm._v(" "), (_vm.showSuggestions) ? _c('ul', {
    staticClass: "suggestion-box"
  }, _vm._l((_vm.filteredMandates), function(item, index) {
    return _c('li', {
      key: 'fm_' + index,
      on: {
        "click": function($event) {
          return _vm.selectThc(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s((item.vehicleno || '').toString().trim()) + " (" + _vm._s((item.thcno || '').toString().trim()) + ")\n        ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.userLoading
    }
  }), _vm._v(" "), (!_vm.userLoading && _vm.userMandates.length) ? _c('table', {
    staticClass: "table-box"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.userMandates), function(user, index) {
    return _c('tr', {
      key: 'um_' + index
    }, [_c('td', [_vm._v(_vm._s(user.createdby))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.hubid))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "delete-btn",
      on: {
        "click": function($event) {
          return _vm.confirmDelete(user)
        }
      }
    }, [_vm._v("Release")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.userLoading && !_vm.userMandates.length) ? _c('p', [_vm._v("No user mandates found.")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activeMainTab === 'UserTrips') ? _c('div', {
    staticClass: "ut-wrapper"
  }, [_c('div', {
    staticClass: "ut-search-card"
  }, [_c('label', {
    staticClass: "ut-label"
  }, [_vm._v("Search by User ID or Email :")]), _vm._v(" "), _c('div', {
    staticClass: "ut-search-row"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "flex": "1",
      "min-width": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userTripSearch),
      expression: "userTripSearch",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "ut-input",
    attrs: {
      "type": "text",
      "placeholder": "Enter User ID or Email"
    },
    domProps: {
      "value": (_vm.userTripSearch)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.userTripSearch = $event.target.value.trim()
      }, _vm.filterUserList],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.showUserSuggestions) ? _c('ul', {
    staticClass: "suggestion-box"
  }, _vm._l((_vm.filteredUserList), function(u, index) {
    return _c('li', {
      key: 'u_' + index,
      on: {
        "click": function($event) {
          return _vm.selectUserTrip(u)
        }
      }
    }, [_vm._v("\n              " + _vm._s(u.userName || u.userId) + "\n            ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "ut-btn-search",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchUserTrips
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "ut-btn-reset",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetUserTripSearch
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.userTripsLoading,
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), (!_vm.userTripSearched && !_vm.userTripsLoading) ? _c('p', {
    staticClass: "ut-hint"
  }, [_vm._v("Please enter a User ID or Email to search trips.")]) : _vm._e(), _vm._v(" "), (_vm.userTripSearched && !_vm.userTripProfile) ? _c('p', {
    staticClass: "ut-hint"
  }, [_vm._v("No user found for the given search.")]) : _vm._e(), _vm._v(" "), (_vm.userTripSearched && _vm.userTripProfile) ? _c('div', [_c('div', {
    staticClass: "ut-profile-card"
  }, [_c('div', {
    staticClass: "ut-avatar"
  }, [_vm._v(_vm._s(_vm.userTripProfile.initials))]), _vm._v(" "), _c('div', {
    staticClass: "ut-profile-info"
  }, [_c('div', {
    staticClass: "ut-profile-name"
  }, [_vm._v(_vm._s(_vm.userTripProfile.name))]), _vm._v(" "), _c('div', {
    staticClass: "ut-profile-meta"
  }, [_vm._v(_vm._s(_vm.userTripProfile.email) + " · ID: " + _vm._s(_vm.userTripProfile.userid))])]), _vm._v(" "), _c('span', {
    staticClass: "ut-status-badge",
    class: _vm.userTripProfile.isActive ? 'active' : 'inactive'
  }, [_vm._v("\n          " + _vm._s(_vm.userTripProfile.isActive ? 'Active' : 'Inactive') + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "ut-stats-row"
  }, [_c('div', {
    staticClass: "ut-stat-card"
  }, [_c('div', {
    staticClass: "ut-stat-num"
  }, [_vm._v(_vm._s(_vm.userTripStats.active))]), _vm._v(" "), _c('div', {
    staticClass: "ut-stat-label"
  }, [_vm._v("Active trips")])]), _vm._v(" "), _c('div', {
    staticClass: "ut-stat-card"
  }, [_c('div', {
    staticClass: "ut-stat-num"
  }, [_vm._v(_vm._s(_vm.userTripStats.inProgress))]), _vm._v(" "), _c('div', {
    staticClass: "ut-stat-label"
  }, [_vm._v("In-Progress")])]), _vm._v(" "), _c('div', {
    staticClass: "ut-stat-card"
  }, [_c('div', {
    staticClass: "ut-stat-num"
  }, [_vm._v(_vm._s(_vm.userTripStats.locked))]), _vm._v(" "), _c('div', {
    staticClass: "ut-stat-label"
  }, [_vm._v("Locked")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-box"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Vehicle / THC No")]), _vm._v(" "), _c('th', [_vm._v("Inbound Start Time")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), (_vm.isAuthorizedForRelease) ? _c('th', [_vm._v("Action")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userTripResults), function(trip, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "ut-vehicle-link"
    }, [_vm._v(_vm._s(trip.vehicleWithThcNo || (trip.vehicleno + ' (' + trip.tripid + ')')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trip.startTime || '-'))]), _vm._v(" "), _c('td', [_c('span', {
      class: ['ut-trip-badge', trip.status === 'Locked' ? 'locked' : 'inprogress']
    }, [_vm._v("\n                " + _vm._s(trip.status) + "\n              ")])]), _vm._v(" "), (_vm.isAuthorizedForRelease) ? _c('td', [_c('button', {
      staticClass: "ut-release-btn",
      on: {
        "click": function($event) {
          return _vm.confirmDelete(trip)
        }
      }
    }, [_vm._v("Release")])]) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.nudgeMessage) ? _c('div', {
    staticClass: "ut-alert-banner"
  }, [_c('span', {
    staticClass: "ut-alert-icon"
  }, [_vm._v("⚠")]), _vm._v("\n        " + _vm._s(_vm.nudgeMessage) + "\n      ")]) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showPendingModal) ? _c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": _vm.closePendingModal
    }
  }, [_vm._v("✕")]), _vm._v(" "), _c('h3', [_vm._v("Pending Bags / MPS")]), _vm._v(" "), _c('div', {
    staticClass: "sub-tabs"
  }, [_c('button', {
    class: ['subtab-btn', _vm.activeTab === 'B2C' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activeTab = 'B2C'
      }
    }
  }, [_vm._v("B2C (Bags)")]), _vm._v(" "), _c('button', {
    class: ['subtab-btn', _vm.activeTab === 'B2B' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activeTab = 'B2B'
      }
    }
  }, [_vm._v("B2B (MPS)")])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.pendingLoading
    }
  }), _vm._v(" "), (_vm.activeTab === 'B2C' && !_vm.pendingLoading) ? _c('table', {
    staticClass: "table-box"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._l((_vm.pendingBags), function(bag) {
    return _c('tr', {
      key: bag.bagno
    }, [_c('td', [_vm._v(_vm._s(bag.bagno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bag.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bag.FinalDestinationName))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "shortage-btn",
      attrs: {
        "disabled": _vm.isBagMarked(bag.bagno) || _vm.markingIds[bag.bagno]
      },
      on: {
        "click": function($event) {
          return _vm.markShortage('B2C', bag)
        }
      }
    }, [(_vm.markingIds[bag.bagno]) ? _c('span', [_vm._v("Marking...")]) : (_vm.isBagMarked(bag.bagno)) ? _c('span', [_vm._v("Already Marked")]) : _c('span', [_vm._v("Mark Shortage")])])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('button', {
    staticClass: "confirm-btn",
    on: {
      "click": function($event) {
        return _vm.confirmInbound(_vm.selectedMandate)
      }
    }
  }, [_vm._v("Confirm")])])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'B2B' && !_vm.pendingLoading) ? _c('table', {
    staticClass: "table-box"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_vm._l((_vm.pendingMps), function(mps) {
    return _c('tr', {
      key: mps.shippingid
    }, [_c('td', [_vm._v(_vm._s(mps.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mps.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mps.finaldestinationhubname))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "shortage-btn",
      attrs: {
        "disabled": _vm.isShipmentMarked(mps.shippingid) || _vm.markingIds[mps.shippingid]
      },
      on: {
        "click": function($event) {
          return _vm.markShortage('B2B', mps)
        }
      }
    }, [(_vm.markingIds[mps.shippingid]) ? _c('span', [_vm._v("Marking...")]) : (_vm.isShipmentMarked(mps.shippingid)) ? _c('span', [_vm._v("Already Marked")]) : _c('span', [_vm._v("Mark Shortage")])])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('button', {
    staticClass: "confirm-btn",
    on: {
      "click": function($event) {
        return _vm.confirmInbound(_vm.selectedMandate)
      }
    }
  }, [_vm._v("Confirm")])])])], 2)]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.showDeleteModal) ? _c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-content small"
  }, [_c('h3', [_vm._v("Confirm Deactivation")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("User:")]), _vm._v(" " + _vm._s(_vm.deleteUserInfo.createdby || (_vm.userTripProfile && _vm.userTripProfile.name) || '-'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Trip ID:")]), _vm._v(" " + _vm._s(_vm.deleteUserInfo.tripid))]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        _vm.showDeleteModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "confirm-btn",
    on: {
      "click": _vm.deactivateUser
    }
  }, [_vm._v("Confirm")])])])]) : _vm._e(), _vm._v(" "), ((!_vm.isCompleteInboundFeatureEnabled || !_vm.isAuthorizedForRelease) && _vm.activeMainTab != 'FMBagging' && _vm.activeMainTab != 'UserTrips') ? _c('div', {
    staticClass: "feature-disabled"
  }, [(!_vm.isAuthorizedForRelease) ? _c('p', [_vm._v("You are not authorized to access this feature.")]) : _c('p', [_vm._v("The Inbound Shortage Request feature is currently disabled. Please contact the administrator for more information.")])]) : _vm._e(), _vm._v(" "), (_vm.activeMainTab === 'FMBagging' && _vm.isFMBaggingFeatureEnabled) ? _c('div', [_c('vue-element-loading', {
    attrs: {
      "active": _vm.isLoading,
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-tabs"
  }, [_c('button', {
    class: ['subtab-btn', _vm.activeFMTab === 'bag' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activeFMTab = 'bag';
        _vm.fmShortageInitiatedRequests(false)
      }
    }
  }, [_vm._v("Bag Shortage Approval")]), _vm._v(" "), _c('button', {
    class: ['subtab-btn', _vm.activeFMTab === 'shipment' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activeFMTab = 'shipment';
        _vm.fmShortageInitiatedRequests(true)
      }
    }
  }, [_vm._v("Shipment Shortage Approval")])]), _vm._v(" "), (_vm.activeFMTab === 'bag') ? _c('div', [(_vm.fmRequestList.length > 0) ? _c('table', {
    staticClass: "table-box"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.fmRequestList), function(m, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(m.createdDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.requestId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.createdBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.bagId))]), _vm._v(" "), _c('td', [_c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "blue"
      },
      on: {
        "click": function($event) {
          return _vm.openFMShipmentModal(m.shipmentIds, m.requestId)
        }
      }
    }, [_vm._v(_vm._s(m.shipmentIds.length) + " "), _c('i', {
      staticClass: "fa fa-external-link",
      staticStyle: {
        "margin-left": "1%"
      }
    })])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.fmRequestList.length == 0) ? _c('p', [_vm._v("No pending bag shortage request found.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activeFMTab === 'shipment') ? _c('div', [(_vm.fmRequestList.length > 0) ? _c('table', {
    staticClass: "table-box"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.fmRequestList), function(m, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(m.createdDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.requestId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.createdBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.bagId))]), _vm._v(" "), _c('td', [_c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "blue"
      },
      on: {
        "click": function($event) {
          return _vm.openFMShipmentModal(m.shipmentIds, m.requestId)
        }
      }
    }, [_vm._v(_vm._s(m.shipmentIds.length) + " "), _c('i', {
      staticClass: "fa fa-external-link",
      staticStyle: {
        "margin-left": "1%"
      }
    })])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.fmRequestList.length == 0) ? _c('p', [_vm._v("No pending shipment shortage request found.")]) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showFMShipmentModal) ? _c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "active": _vm.pendingLoading,
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-box"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Pending Shipping IDs\n              "), _c('button', {
    staticClass: "fmclose",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showFMShipmentModal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.fmShipmentList), function(m) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(m))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.markFMShortage()
      }
    }
  }, [_vm._v("Approve")])])])], 2)])], 1)]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("THC No")]), _vm._v(" "), _c('th', [_vm._v("Vehicle No")]), _vm._v(" "), _c('th', [_vm._v("Connection Name")]), _vm._v(" "), _c('th', [_vm._v("Pending Bags")]), _vm._v(" "), _c('th', [_vm._v("Pending MPS")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("User Name")]), _vm._v(" "), _c('th', [_vm._v("Hub ID")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Bag No")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Final Destination")]), _vm._v(" "), _c('th', [_vm._v("Mark Shortage")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("MPS")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Final Destination")]), _vm._v(" "), _c('th', [_vm._v("Mark Shortage")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date & Time")]), _vm._v(" "), _c('th', [_vm._v("Request ID")]), _vm._v(" "), _c('th', [_vm._v("Requested By")]), _vm._v(" "), _c('th', [_vm._v("Bag Number")]), _vm._v(" "), _c('th', [_vm._v("Missing AWBs")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date & Time")]), _vm._v(" "), _c('th', [_vm._v("Request ID")]), _vm._v(" "), _c('th', [_vm._v("Requested By")]), _vm._v(" "), _c('th', [_vm._v("Bag Number")]), _vm._v(" "), _c('th', [_vm._v("Missing AWBs")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f28ae40","hasScoped":true}!./src/views/components/InboundMandate/InboundMandate.html
// module id = 2035
// module chunks = 2